module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/disabled-pattern.6100355c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/disabled-pattern.png
// module id = 2835
// module chunks = 11